import {
  BoxGeometry,
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Veigar mesh — tiny frame + hat + dark matter orb (OCP registry). */
export function createVeigarMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x7c3aed : 0x4c1d95;
  const robeMat = new MeshStandardMaterial({ color: 0x1e1b4b, roughness: 0.55 });
  const hatMat = new MeshStandardMaterial({ color: trim, roughness: 0.4 });
  const orbMat = new MeshStandardMaterial({
    color: 0xa78bfa,
    roughness: 0.3,
    emissive: 0x6d28d9,
    emissiveIntensity: 0.3
  });

  const body = new Mesh(new ConeGeometry(0.75, 1.7, 10), robeMat);
  body.position.y = 1.1;
  group.add(body);

  const head = new Mesh(new SphereGeometry(0.32, 12, 12), robeMat);
  head.position.y = 2.15;
  group.add(head);

  const brim = new Mesh(new CylinderGeometry(0.7, 0.7, 0.08, 12), hatMat);
  brim.position.y = 2.4;
  group.add(brim);

  const tip = new Mesh(new ConeGeometry(0.35, 0.9, 8), hatMat);
  tip.position.y = 2.9;
  group.add(tip);

  const orb = new Mesh(new SphereGeometry(0.28, 10, 10), orbMat);
  orb.position.set(0.7, 1.5, 0.25);
  group.add(orb);

  const book = new Mesh(new BoxGeometry(0.35, 0.1, 0.45), hatMat);
  book.position.set(-0.55, 1.35, 0.2);
  group.add(book);

  return group;
}
